import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";

export default function Button({
  btnText,
  btnUrl,
  className,
  variantColor,
  noarrow,
  img,
}) {
  return (
    <Link
      to={btnUrl}
      className={`cs_btn cs_style_1  ${variantColor ? variantColor : ""} ${
        className || ""
      }`}
    >
      {img && <img src={img} alt="Button Image" />}
      {btnText}

      {noarrow == null && (
        <span>
          <i>
            <Icon icon="fa6-solid:arrow-right" />
          </i>
          <i>
            <Icon icon="fa6-solid:arrow-right" />
          </i>
        </span>
      )}
    </Link>
  );
}
